<template lang="html">
  <my360FormGroup>
    <label
      v-if="label"
      :for="prop">
      {{ label }}
    </label>

    <select
      v-model="propPath"
      v-bind="attributes"
      :validationName="validationName"
      :prop="prop"
      :name="attributes.name ? attributes.name : prop"
      :class="classNames">
      <option
        :label="__('select_placeholder_text')"
        value=""
        disabled
        selected>
        {{ __('select_placeholder_text') }}
      </option>
      <option
        v-for="(option, optionKey) in options"
        :key="optionKey"
        :value="getOptionValue(option, optionKey)"
        :label="getOptionLabel(option, optionKey)">{{ getOptionLabel(option, optionKey) }}</option>
    </select>

    <div
      v-if="hasKey(errorBag, prop)"
      class="invalid-feedback">
      <i class="far fa-times-circle" />
      {{ getErrorMessage }}
    </div>
  </my360FormGroup>
</template>
<script>
import inputType from '../../mixins/inputType'

export default {
  name: 'My360Select',

  mixins: [inputType],

  props: {
    options: {
      type: [Object, Array],
      required: true
    },

    valueKey: {
      type: String,
      required: false,
      default: () => { return 'value' }
    },

    labelKey: {
      type: String,
      required: false,
      default: () => { return 'label' }
    },

    labelFormatter: {
      type: Function,
      required: false,
      default: () => { return null }
    }
  },

  computed: {
    defaultClassNames () {
      return 'bg-light-grey'
    }
  },

  methods: {
    getOptionValue (op, key) {
      if (typeof op === 'object') {
        return op[this.valueKey]
      }
      if (key) {
        return key
      }
      return op
    },

    getOptionLabel (op, key) {
      if (this.labelFormatter()) {
        return this.labelFormatter(op, key)
      }
      if (typeof op === 'object') {
        return op[this.labelKey]
      }
      return op
    }
  }
}
</script>
